import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import Carousel from './carousel-component';
import { setActiveIndex } from './redux/action';

const mapStateToProps = (state: ApplicationState) => ({
  images: state.devices.detail.general.bucket,
  carousel: state.carousel,
  t: state.i18n.t
});

export default connect(mapStateToProps, { setActiveIndex })(Carousel);
